export const data = (date,param) => {
  if (!date ||!param || /^0000-00-00/.test(`${date}`)) return '';
  let  timeArry = date.split("-");
  switch (param){
    case "DAY":
      return timeArry[2];
      break;
    case "YEARMON":
      return timeArry[0]+"."+timeArry[1];
      break
    case ".":
       return timeArry[0]+"."+timeArry[1]+"."+ timeArry[2];
    case "YEAR_DAY" :
      return timeArry[0]+"."+timeArry[1];
    default:
       return  timeArry
  }
}

